<a class="workspace mb-2" routerLink="/workspaces/{{workspace.id}}">
  <img class='ws-img rounded' src="assets/images/type_workspace.svg" alt="">
  <div class="workspace-info-container">
    <div class="ws-title">{{workspace?.name}} <img *ngIf='workspace.isBookmarked' src="assets/images/favourite.svg" alt=""></div>
    <div *ngIf="workspace.shared" class="ws-shared">
      <app-shared-with big=[true] [title]="workspace?.sharedWith?.length > 1 ? 'Shared with' : '-'" [sharedWithList]="workspace?.sharedWith"></app-shared-with>
    </div>
    <div *ngIf="!workspace.shared" class="ws-subtitle">
      Edited {{workspace?.lastUpdated * 1000 | date:'EEEE, MMMM d'}} at {{workspace?.lastUpdated * 1000 | date:'HH:mm'}}
    </div>
    <ng-content></ng-content>
  </div>
</a>
